import { registerQuery } from 'data-fetching-client';

import { ecosystemAppClient } from 'marketplace-ui-common/clients/ecosystemClient';

import { ReviewType } from '../types';

export const GET_REVIEWABILITY = registerQuery({
  fieldName: 'reviewability',
  fetcher: (queries: {
    entityId: number;
    entityPortalId: number;
    type: ReviewType;
  }) =>
    ecosystemAppClient.post(`reviews/reviewability/check`, {
      data: { ...queries },
    }),
});
